import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class FactorLimiteCompraCuotas extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;
        let props = this.props;
        let seEstaEditando = props.dataCompleto.seEstaEditando;

        errorContainer = <label className="error">
            {(errors = getFieldError('factorLimiteCompra')) ? errors.join(',') : null}</label>

        let error = (getFieldError('factorLimiteCompra')) ? true : false

        //////////Novedad en FLLC////////////
        let descripcion = props.data.Flcc;
        let novedadFlcc = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedadFlcc = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadFlcc) {
                const esNovedadEditadaDescripcion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDescripcion == false) {
                    descripcion = novedadFlcc.ValorNovedad;
                }
            }
        }
        ////////////////////////////////////////////////////
        let panel = null;

        if (props.data.accountData.FlccEsModificable == true) {
            let componente = <div>
                <GenericInputValidate
                    getFieldProps={getFieldProps('factorLimiteCompra', {
                        onChange(e) {
                            me.changeInput(e);
                        },
                        rules: [{
                            required: true,
                            pattern: /^(?=.*[1-9])\d{0,2}(?:\.\d{0,1})?$/,
                            message: 'Debe ingresar código válido.'
                        }]
                    })}
                    id="factorLimiteCompra"
                    name="factorLimiteCompra"
                    value={descripcion}
                    className="form-control default-input"
                    autoComplete="off"
                />
                {errorContainer}
            </div>

            panel = <GenericEditPanel
                componente={componente}
                cuenta={props.data}
                error={(error || (descripcion == undefined || descripcion == ""))}
                novedad={novedadFlcc}
                seEstaEditando={seEstaEditando}
                permisoUsuario={props.dataCompleto.funcionesDelUsuario}
                textPanel={descripcion || "Sin especificar"}
                title="Factor de límite de compra en cuotas (FLCC)"
                value={descripcion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadFlcc, 2, props.data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadFlcc, 3, props.data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        } else {
            panel = (
                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Factor de límite de compra en cuotas (FLCC)</label>
                    </div>
                    <div className="col-xs-12">
                        <label className="label-secondary" >{descripcion}</label>
                    </div>
                </div>
            );
        }

        return panel;
    }
}

export default FactorLimiteCompraCuotas;